import {RemoteNodeInsightsDataWithSource} from '../campaignAnalytics.types';
import _some from 'lodash/some';
import {isInsightOfCurrentVersionFallbackCreative} from './isInsightOfCurrentVersionFallbackCreative';
import {Nodes} from 'common/src/modules/decisionTree/decisionTree.types';

export function isInsightsOfCurrentVersionConnector({
  nodes,
  insightOutput,
  fallbackCreativeNodeId,
  sourceNodeId,
}: {
  nodes: Nodes;
  insightOutput: RemoteNodeInsightsDataWithSource;
  fallbackCreativeNodeId: number;
  sourceNodeId: number;
}) {
  const isOutputToFallbackCreative = isInsightOfCurrentVersionFallbackCreative({
    sourceNodeId: insightOutput.sourceNodeId,
    fallbackCreativeNodeId,
    targetNodeId: insightOutput.targetNodeId,
  });

  return (
    isOutputToFallbackCreative ||
    _some(
      nodes[sourceNodeId].outputs,
      (output) =>
        output.nodeId === insightOutput.targetNodeId && output.id === insightOutput.outputId,
    )
  );
}
